var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoneyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 23,
    viewBox: "0 0 27 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 23,
    fill: "url(#pattern0_6_80)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_6_80",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_6_80",
    transform: "matrix(0.027027 0 0 0.0317274 0 -0.00763807)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_6_80",
    width: 37,
    height: 32,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACUAAAAgCAYAAACVU7GwAAAACXBIWXMAAAsTAAALEwEAmpwYAAADdUlEQVRYhb3X63MURRQF8N+SzQYkhmQRX4EsapmUqBBU9IuifvD/tizUUsHyxUsxMYkglGBQoXgkJH643c4y6WxCHnuqUjWZuTN9+vS5p3sH9BctdPA0/l6vqNknMs8kMs9jD1bwB5ZKxQO7SGQIL2EaL2MvFjCLF/EAi6UXd0OpuiqL+AXX8CjVvJJqZnaT1BAmcAT7xbL8JpT5p1A/h+No46+dJNXwuCqNNMDPQpWGWKYjuKRSCa7iWJrIjpDKqkzgKaHKLObxL0bSgIcxmN4ZxQ/pOSwn4uM4r2b4xiaJNHAoEcmq3EpEulXpYEzVXfMiBk4IAe4Ig2flTuOnNKlNk9qrUmUfHuJ34Yk7QpWOUKWJu+nZQqrNGBLLOIaDIqO+xIeJw6fdg5aWL6vSwXNdqlxMs28I2U+KZcmqzKW6Eh7gSrqexJRoiDm8qWb4blIlVWZrqrxeU+VCQZWNsJCIdURTrDF8EwcS82eTCiuiO66n6xGVKoQpZ1SqtJ+AUMZdMbnZNNa48NayROJjDG/hwzuBP4XpP8CPIts0xVZzIz3sJ6ZF4t8WAdvpJkV4op68+1VLuh2sCCvcr91f7rrOhh/F7V7hOW1rfimhjW97PM8J3+lFajx96KKYxXYwhaN6R8aSroSvk2qK48aU2N1nhPx1NMTSjmEVN3sMeDnVvqeKkEeFunkRsON1Uh+JjLqO79Yh1MIpoeRqujcpmuVcYcAlfIG3hW8O40zX8wHVFgUH66T2CXXOF8hkvCUM+b3YchpieY7hjXS/jvv4HO+o8o7IwE/Exp3DeL7kqe6uGE4zyefpEbEFXRByZ/yaJnRU+DAn/FgidK/wbenba7aoPQVSGQ2xTCfFFkQc+ImlquNGeicH8QGh3Ls9xlgUXfmYH3tFwqrIrkHVzLNfWoX6wVrNPeHJNYe4jbDRIe9c7f9badBJfK1qhAG8KpYqh/BD4aMnRp3UqvDMVXEyqGNJNMFxvJ/qGqpT6FlVR9YxKjy2IeqeuiJ8c1qcMEuYEwo2Rce9JtT7SkRJCRNiEi3RFD1RV+qS2BRPidb/TFmxa+mvJZQp/qhMaAtlb6bJ9KotkiJ88Y040pxIH9sOXkjfPGttJGyaVCY2Iwy9E5vy/we47ZAi9qzL26azBWRSbXFU6SeGlf2qKY6kh8Sv3X5i3WD9Dwlo5OuTE4HeAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyIcon);
export default __webpack_public_path__ + "static/media/money-icon.3b0467a62e0d2be8bd64a99cc1f5d180.svg";
export { ForwardRef as ReactComponent };